<mat-form-field floatLabel="auto" appearance="outline" class="w-100">
  <mat-label>{{ label }}</mat-label>
  <input
    [autocomplete]="autocomplete"
    #nativeElement
    [type]="hide ? 'password' : 'text'"
    matInput
    [formControl]="control"
    [placeholder]="placeholder"
  />
  <button
    type="button"
    *ngIf="control.value"
    mat-icon-button
    matSuffix
    (mousedown)="hide = false"
    (mouseup)="hide = true"
    (mouseleave)="hide = true"
  >
    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
  </button>
  <mat-icon *ngIf="!control.value && control.invalid && (control.dirty || control.touched)" matSuffix class="mat-error"
    >error</mat-icon
  >
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngIf="control.invalid && (control.dirty || control.touched) && errorMessage" [id]="id + '-error'">{{
    errorMessage
  }}</mat-error>
</mat-form-field>
